<template>
   <div class="scrollableY">
        <div class="has-text-white top40 " :class="{cmsInAccWidther: !$parent.userAttrs, container: $parent.userAttrs}">
            <div class="is-size-3 settsPad">FAQ</div>
    
            <faqitem class="settsPad" v-for="(item, i) in faqs" :key="i" :item="item"></faqitem>
            <br><br><br><br><br><br>
        </div>
       <!--  <footerDiv></footerDiv> -->
   </div>
</template>

<script>

import faqitem from '../components/FAQitem'
const faqs = require('../static/faqs.js')
import footerDiv from './Footer.vue'
export default{
    name: 'settsFAQ',
    components: {faqitem, footerDiv},

    data: function(){
        return {
          faqs: faqs,
        }
    }
}
</script>